import { bool, func } from 'prop-types'
import Action from '../Action'

const Remover = ({ removable, onRemove }) => {
  if (removable) {
    return <Action icon="close-sm" handler={onRemove} />
  }
  return null
}

Remover.propTypes = {
  onRemove: func,
  removable: bool,
}

export default Remover
